module.exports = __webpack_public_path__ + "img/bowen3.bab55cf4.png";